import React from 'react';
import { Empty } from 'antd';
import Card, { CardHeader, CardButton } from '../../../../../components/Card';
import styles from './ExpandedRowCard.module.scss';

const ExpandedRowCard = ({
  classNames,
  title,
  action,
  bodyContent,
  btnProps = {},
}) => {
  return (
    <Card className={classNames.card}>
      <CardHeader
        title={title}
        action={action}
        titleProps={{ className: classNames.title }}
        className={styles.header}
      />
      <div className={styles.body}>
        {bodyContent ? (
          bodyContent
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </div>

      {Boolean(Object.keys(btnProps).length) && (
        <CardButton
          className={classNames.btn}
          block
          {...btnProps}
        />
      )}
    </Card>
  );
};

export default ExpandedRowCard;
